import styled from "styled-components";

export const TableContainer = styled.div`
  height: calc(100% - 270px);
  flex: 1 1 1px;
`;
export const Table = styled.table`
  display: flex;
  flex-flow: column;
  border-collapse: collapse;
  font-size: 0.9em;
  flex: 0 0 auto;
  width: calc(100% - 0.9em);
  width: 100%;
  height: 100%;
`;
export const Thead = styled.thead`
  flex: 0 0 auto;
  width: calc(100% - 0.9em);
  width: 100% !important;
  display: table;
  table-layout: fixed;
`;
export const TheadRow = styled.tr`
  background-color: ${(props) => props.color};
  color: #ffffff;
  text-align: left;
  width: 100%;
`;
export const TableHeader = styled.th`
  padding: 8px 5px;
  width: ${(props) => (props.width ? `${props.width}%` : "25%")};
`;
export const TableHeaderIcon = styled.th`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 5px;
`;
export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
export const TableBody = styled.tbody`
  flex: 1 1 1px;
  height: 100%;
  display: block;
  overflow-y: scroll;
`;
export const BodyRow = styled.tr`
  border-bottom: 1px solid #dddddd;
  width: 100%;
  display: table;
  table-layout: fixed;

  &:last-child {
    border-bottom: 2px solid lightgray;
  }
`;
export const LoadingRow = styled.tr`
  width: 100%;
  display: table;
  table-layout: fixed;
`;
export const TD = styled.td`
  padding: 3px;
  text-align: center;
`;

export const style = (theme) => ({
  fontSizeInherit: {
    fontSize: "16px",
  },
});
